import IconTimes from "@Icons/controls/IconTimes";
import {ReactNode} from "react";

interface MobileOverlayActionSheetHeaderProps {
    className?: string,
    children?: ReactNode,
    closeSheet?: () => void,
}

function MobileOverlayActionSheetHeader({className = "", children, closeSheet}: MobileOverlayActionSheetHeaderProps) {
    return (
        <div className={`action-sheet__header ${className}`}>
            <div className="action-sheet__header-notch"/>
            {!!closeSheet && (
                <button type="button" onClick={closeSheet} className="action-sheet__header-close">
                    <IconTimes/>
                </button>
            )}
            {children && (
                <>
                    {children}
                </>
            )}
        </div>
    )
}

export default MobileOverlayActionSheetHeader